import { t, Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Button, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

import { InsOperation } from '@/core/models/ins-audit.model'
import { insAuditOperationMessages } from '@/pages/patient/lib/ins-audit-labels'

export type InsAuditLogsFiltersProps = {
  operation?: InsOperation
  onOperationChange: (value: InsOperation | undefined) => void
  searchQuery: string
  onSearchChange: (query: string) => void
  onReset: () => void
}

export function InsAuditLogsFilters({ operation, onOperationChange, searchQuery, onSearchChange, onReset }: InsAuditLogsFiltersProps) {
  const lingui = useLingui()

  return (
    <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
      <FormControl size="small" sx={{ minWidth: 220 }}>
        <InputLabel id="operation-filter-label">
          <Trans>Operation</Trans>
        </InputLabel>
        <Select
          labelId="operation-filter-label"
          label={t`Operation`}
          value={operation ?? t`ALL_OPERATIONS`}
          onChange={(event) => onOperationChange(event.target.value ? (event.target.value as InsOperation) : undefined)}
        >
          <MenuItem value={t`ALL_OPERATIONS`}>
            <Trans>All operations</Trans>
          </MenuItem>
          {Object.values(InsOperation).map((op) => (
            <MenuItem key={op} value={op}>
              {lingui._(insAuditOperationMessages[op])}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        size="small"
        placeholder={t`Search by patient, INS identity number or OID`}
        value={searchQuery}
        onChange={(event) => onSearchChange(event.target.value)}
        sx={{ minWidth: 280 }}
        InputProps={{
          startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />,
        }}
      />

      <Button variant="outlined" size="small" onClick={onReset}>
        <Trans>Reset</Trans>
      </Button>
    </Stack>
  )
}
